// This middleware is to clean up blocked urls in GSC.
// Old urls with page[number] is still being indexed and crawled.
// New format for pagination: ?page=2

export default defineNuxtRouteMiddleware((to) => {
	const fullPath = to.fullPath
	const decodedPath = decodeURIComponent(fullPath)

	// The Logic: Kill the request if it contains 'page[' and 'filter['.
	// or if it contains multiple question marks (a sign of a malformed URL)
	// We have switch to using 'page=' and no longer using 'filter['.

	const forbiddenPatterns = ['page[', 'filter[']

	const hasForbiddenBrackets = forbiddenPatterns.some((pattern) =>
		decodedPath.includes(pattern)
	)

	// The login page's _redirect is an address of its own, so it can carry a ? too
	const pathWithoutRedirect = fullPath.replace(/([?&])_redirect=[^&]*/, '$1')
	const hasMultipleQM = (pathWithoutRedirect.match(/\?/g) || []).length > 1

	if (hasForbiddenBrackets || hasMultipleQM) {
		throw createError({
			statusCode: 410,
			statusMessage: 'Page not found',
			fatal: true,
		})
	}
})
